import * as R from "fp-ts-routing"

import * as matches from "./matches"
import * as C from "./types"
import type { Routes } from "./types"

const router = R.zero<Routes>()
  .alt(matches.AdminCustomActionReader.parser.map(C.adminCustomActionReader))
  .alt(matches.CapabilityForm.parser.map(C.capabilityForm))
  .alt(matches.CapabilityFormRetry.parser.map(C.capabilityForm))
  .alt(matches.GotthardKeyNewForm.parser.map(C.gotthardKeyNewForm))
  .alt(matches.GotthardKeyEditForm.parser.map(C.gotthardKeyEditForm))
  .alt(
    matches.NewAdminSsoConfirmationForm.parser.map(
      C.NewAdminSsoConfirmationForm
    )
  )
  .alt(
    matches.EditAdminSsoConfigurationForm.parser.map(
      C.EditAdminSsoConfigurationForm
    )
  )
  .alt(
    matches.DestroyAdminSsoConfigurationForm.parser.map(
      C.DestroyAdminSsoConfigurationForm
    )
  )
  .alt(matches.NewAdminCustomActionForm.parser.map(C.newAdminCustomActionForm))
  .alt(
    matches.EditAdminCustomActionForm.parser.map(C.editAdminCustomActionForm)
  )
  .alt(matches.AdminScenarioTransfers.parser.map(C.adminScenarioTransfers))
  .alt(matches.AdminPartnerList.parser.map(C.adminPartnerList))
  .alt(matches.AdminPartnerDetail.parser.map(C.adminPartnerDetail))
  .alt(matches.PartnerScenarioTransfers.parser.map(C.partnerScenarioTransfers))
  .alt(matches.PartnerOrganizations.parser.map(C.partnerOrganizations))
  .alt(matches.PartnerRoot.parser.map(C.partnerOrganizations))
  .alt(matches.PartnerProjects.parser.map(C.partnerProjects))
  .alt(matches.ScenarioList.parser.map(C.scenarioList))
  .alt(matches.ScenarioEditor.parser.map(C.scenarioEditor))
  .alt(matches.ScenarioHistory.parser.map(C.scenarioHistory))
  .alt(matches.CompareScenarioHistory.parser.map(C.compareScenarioHistory))
  .alt(matches.StepGroupList.parser.map(C.stepGroupList))
  .alt(matches.StepGroupEditor.parser.map(C.stepGroupEditor))
  .alt(matches.TestPlanList.parser.map(C.testPlanList))
  .alt(matches.TestPlan.parser.map(C.testPlan))
  .alt(matches.TestPlanScenarioList.parser.map(C.testPlanScenarioList))
  .alt(matches.TestCaseResults.parser.map(C.testCaseResults))
  .alt(matches.UserSettings.parser.map(C.userSettings))
  .alt(matches.ProjectSettingsList.parser.map(C.projectSettingsList))
  .alt(matches.CustomActionDependents.parser.map(C.customActionDependents))
  .alt(matches.NewCustomActionForm.parser.map(C.newCustomActionForm))
  .alt(matches.EditCustomActionForm.parser.map(C.editCustomActionForm))
  .alt(matches.TriggerEditor.parser.map(C.triggerEditor))
  .alt(matches.NewCustomActionForm.parser.map(C.newCustomActionForm))
  .alt(matches.TrialFormSettings.parser.map(C.trialFormSettings))
  .alt(matches.TrialFormUsage.parser.map(C.trialFormUsage))
  .alt(matches.TrialForm.parser.map(C.trialForm))
  .alt(matches.TestPlanResultList.parser.map(C.TestPlanResultList))
  .alt(matches.AutifyUsageReport.parser.map(C.report))
  .alt(matches.CreditUsageReport.parser.map(C.report))
  .alt(matches.Project.parser.map(C.project))
  .alt(matches.DomSnapshot.parser.map(C.domSnapshot))
  .alt(matches.Graphiql.parser.map(C.graphiql))
  .alt(matches.TestPlanCapabilityResult.parser.map(C.testPlanCapabilityResult))

export function parse(pathname: string): Routes | null {
  return R.parse(router, R.Route.parse(pathname), null)
}

function format<T>(match: R.Match<T>) {
  return (params: T): string => R.format(match.formatter, params)
}

const routes = {
  matches,
  format,
}

export { routes }
